import { Selection } from 'components/pspdf/components/selection';
import { renderToString } from 'react-dom/server';
import { ServerStyleSheet } from 'styled-components';
import { isEqual } from 'lodash';
const sheet = new ServerStyleSheet();

function isCustomAnnotation(annotation: any): boolean {
  return annotation.customData?.type === 'custom';
}

function customAnnotationTemplate(annotation) {
  const node = document.createElement('div');
  node.setAttribute('id', annotation.toJS().customData?.annotationId);
  const style = `width: ${annotation.boundingBox.width}px; height: ${annotation.boundingBox.height}px; position: relative;`;

  node.setAttribute('style', style);

  return {
    node,
    append: true,
  };
}

export function customAnnotation(
  instance,
  annotation,
  selectedAnnotation,
  customAnnotationRenderer,
  renderedAtRef,
) {
  const isSelected = isEqual(annotation, selectedAnnotation);

  if (isCustomAnnotation(annotation)) {
    const customAnnotation = customAnnotationTemplate(annotation);

    const selection = new Selection(annotation, instance);

    const html = renderToString(
      sheet.collectStyles(
        customAnnotationRenderer(
          annotation,
          isSelected,
          instance.contentDocument,
          selection,
          renderedAtRef.current,
        ),
      ),
    );

    const styleTags = sheet.getStyleTags();

    customAnnotation.node.innerHTML = '';
    customAnnotation.node.innerHTML = styleTags + html;

    return { ...customAnnotation, append: true };
  }
}
